export class UserRegistration
{
    public token: string;
    public valid: boolean;
    public username: string;
    public password: string;
    public registered: boolean;
    public community = false;
}


